@if (ui<2) {
  @if (canShowInheritance) {
    <div class="inheritance-wrapper" [ngClass]="{readonly:isCheckedBoxReadOnly}">
      <input type="text" tabindex="0" class="checkbox" [ngClass]="{checked:isChecked}" (click)="onCheckChange($event)">
      <span class="checklabel customLabelSpan" (click)="onCheckChange($event)">
        {{ this.localizer.getTranslation('FORMS.LOCAL.PERMISSIONS_SELECTOR.INHERIT_FROM', [getInheritedFromName()]) }}
      </span>
    </div>
  }
  <edx-action-bar [menuID]="actionMenuId" [target]="this" #actionbar></edx-action-bar>
  @if (massProfile) {
    <div class="selwrapper" [ngClass]="{disablelist:isReadOnly}">
      <edx-select id="edx_security_option"
        [items]="trusteesDirectives"
        [value]="trusteesDirective"
        (change)="setRrusteesDirective($event)">
      </edx-select>
    </div>
  }
  <div class="list" [ngClass]="{footer:showFooter,
                                disablelist:isReadOnly,
                                massprofile:massProfile,
                                canInherit: canShowInheritance}">
    @if (detailView) {
      <edx-list-table #table
        (detailviewnotify)='onGranularRightChange($event)'
        [schemaId]="'ACCESS_CONTROL'"
        [desc]="desc"
        [params]="'security'"
        [inlineActionMenuId]="6"
        [inlineActionTarget]="this"
        [parent]="this"
        [readOnly]="isChecked" [disableSecurity]="isReadOnly">
      </edx-list-table>
    }
    @if (!detailView) {
      <edx-list-table #table
        (summaryviewnotify)='onTemplateRightChange($event)'
        [schemaId]="'SECURITY'"
        [desc]="desc"
        [params]="'security'"
        [inlineActionMenuId]="6"
        [inlineActionTarget]="this"
        [parent]="this"
        [readOnly]="isChecked" [disableSecurity]="isReadOnly">
      </edx-list-table>
    }
  </div>
  @if (showFooter) {
    <edx-list-info-footer [displayItems]="footerItems" [heading]="footerHeading"></edx-list-info-footer>
  }
}

@if (ui>=2) {
  @if (canShowInheritance) {
    <div
      class="inheritance-wrapper"
      [ngClass]="{tablet: tablet, mobile: mobile}">
      <otc-checkbox #inheritCheckbox [aria-checked]="isChecked"
        [tabindex]=0
        [checked]="isChecked"
        [readonly]="isCheckedBoxReadOnly"
        (change)="onCheckChange($event)">
        {{ this.localizer.getTranslation('FORMS.LOCAL.PERMISSIONS_SELECTOR.INHERIT_FROM', [getInheritedFromName()]) }}
      </otc-checkbox>
    </div>
  }
  @if (tablet) {
    <edx-action-bar [menuID]="actionMenuId" [target]="this" [forceDekstopLook]="true" #actionbar></edx-action-bar>
  }
  <div class="header">{{permissions}}</div>
  @if (massProfile) {
    <div class="selwrapper" [ngClass]="{disablelist:isReadOnly}">
      <edx-select id="edx_security_option"
        [items]="trusteesDirectives"
        [value]="trusteesDirective"
        (change)="setRrusteesDirective($event)">
      </edx-select>
    </div>
  }
  <div class="list mobile" [ngClass]="{tablet:tablet, ios:iOS,
                                        massprofile:massProfile,
                                        disablelist:isReadOnly,
                                        canInherit: canShowInheritance}"
    [edx-gesture-longpress]="table" [edx-gesture-swipe]="table" [edx-gesture-doubletap]="table">
    <edx-list-mobile #table (summaryviewnotify)='onTemplateRightChange($event)'
      [schemaId]="'SECURITY'"
      [desc]="desc"
      [params]="'security'"
      [inlineActionMenuId]="6"
      [inlineActionTarget]="this"
      [parent]="this"
      [splitView]="splitView"
      [hasFootprint]="inDialog"
      [hasHeader]="true"
      [disableSecurity]= "isReadOnly"
      >
    </edx-list-mobile>
  </div>
  @if (!tablet) {
    <edx-action-bar [menuID]="actionMenuId" [target]="this" #actionbar></edx-action-bar>
  }
}